import axios from "axios";
import { message } from "antd";

const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

const createRazorypayOrder = (
  amount,
  barcode,
  visitorPhoneNumber,
  visitorEmailId,
  visitorName,
  onPaymentSuccess
) => {
  let data = JSON.stringify({
    amount: amount,
    currency: "INR",
    barcode: barcode,
  });
  
  axios
    .post(`${process.env.REACT_APP_API_END_POINT}/payment-request`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((resData) => {
      handleRazorpayScreen(
        resData.data.amount,
        barcode,
        new Date().toISOString(),
        visitorPhoneNumber,
        visitorEmailId,
        visitorName,
        onPaymentSuccess
      );
    })
    .catch((error) => {
      console.log("error in payment:=>", error.message);
      message.error("Payment initialization failed. Please try again.");
      if (window.setPaymentLoading) {
        window.setPaymentLoading(false);
      }
    });
};

const handleRazorpayScreen = async (
  amount,
  barcode,
  time,
  visitorPhoneNumber,
  visitorEmailId,
  visitorName,
  onPaymentSuccess
) => {
  const res = await loadScript(
    "https://checkout.razorpay.com/v1/checkout.js"
  );
  if (!res) {
    message.error("Payment system could not be loaded. Please try again.");
    return;
  }
  
  const options = {
    key: process.env.REACT_APP_RAZORPAY_API_KEY,
    amount: amount,
    currency: "INR",
    name: "KCE",
    description: "Payment for Extra Staff Member",
    image: "https://cdnapp.kolkatacoutureexpo.com/media/logo192.png",
    notes: { barcode, type: "extra_member" },
    handler: function (response) {
      console.log("Payment successful:", response);
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/payment/${response.razorpay_payment_id}/${barcode}/success`
        )
        .then((payment_Data) => {
          message.success("Payment successful! Registering staff member...");
          
          if (onPaymentSuccess && typeof onPaymentSuccess === 'function') {
            onPaymentSuccess();
          } else {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        })
        .catch((error) => {
          console.log("Payment confirmation error:", error);
          message.error("Payment confirmation failed. Please contact support.");
        });
    },
    modal: {
      ondismiss: function (response) {
        console.log("Payment dismissed:", response);
        axios
          .get(
            `${process.env.REACT_APP_API_END_POINT}/payment/demo/${barcode}/failed`
          )
          .then((payment_Data) => {
            console.log("Payment failed:", payment_Data.data);
          })
          .catch((error) => {
            console.log("Payment failure tracking error:", error);
          });
        
        message.warning("Payment was cancelled. You need to complete payment to add extra members.");
      },
    },
    prefill: {
      name: visitorName,
      email: visitorEmailId,
      contact: visitorPhoneNumber,
    },
    theme: {
      color: "#F4C430",
    },
  };
  
  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
};

export { createRazorypayOrder, handleRazorpayScreen };